import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
// eslint-disable-next-line import/no-cycle
import { apiGet } from '@/store/api';
import { GlobalHelperFunctions } from '@/common/GlobalHelperFunctions';
import { useToolbarStore } from '@/store/toolbarStore';
import ProformaLines from './ProformaLines.vue';

interface GatResponseResult<T> {
  message: string;
  /** The response result */
  payload?: T;
  syncChanges: any;
  resultType: any;
}

// Define the data structure based on the backend response
interface ProformaInfo {
  proformaId: string;
  VESSEL_NAME: string;
  vesselId: string;
  ETA: string;
  ETD: string;
  DESCRIPTION: string;
  PROFORMA_NUMBER: string;
  AGENCY_ID: string;
  HARBOUR_ID: string;
  CLIENT_ID: string;
  VESSEL_TYPE: string;
  clientName: string;
  harbourName: string;
  agencyName: string;
  terminalName: string;
  quayName: string;
  GT: number;
  NT: number;
  DWT: number;
  LOA: number;
  BEAM: number;
  LOADED_Q: number;
  DISCH_Q: number;
  SUMMERDRAFT: number;
  DRAFT: number;
  DRAFT_DEPARTURE: number;
  DRAFT_ARRIVAL: number;
  CSI: number;
  ESI: number;
  PAX_CAP: number;
  SBT: number;
  CBM: number;
  USER_FIELD1: string | null;
  HISTORY: string;
  LOCAL_CURRENCY: string;
  LOCKED: boolean;
  LOCKED_COMMMENT: string | null;
  INQUIRY_ID: string;
  CREATED_DATE: Date;
  DOC_FOLDER: string;
  PORTCALL_ID: string;
  CUR_CODE1: string;
  CUR_CODE2: string;
  CUR_CODE3: string;
  CUR_CODE4: string;
  SUBTOTAL_IN: number;
  COMMENTS_NEW: string;
}

interface Currency {
  currencyName: string;
  rate: number;
}

interface ProformaWindow {
  proformaInfo: ProformaInfo;
  currencies: Currency[];
  proformaLines: any[];
}

interface ProformaProps {
  proformaId: string;
  callId: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Proforma',
  props: {
    proformaId: null,
    callId: null
  },
  setup(__props: any) {

const props = __props as {
  proformaId: string;
  callId: string;
};


const isLoading = ref(false);
const proformaWindow = ref<ProformaWindow | undefined>(undefined);
const toolbarStore = useToolbarStore();

// Fetch the proforma data from API

function globalFormatDateTime(date: any, format: any) {
  return GlobalHelperFunctions.globalFormatDateTime(date, format);
}

const columns = computed(() => {
  const result: any[] = [
    { header: 'Currency name', field: 'currencyName', dataType: 'string' },
    { header: 'Rate', field: 'rate', dataType: 'number' },
  ];
  return result;
});

async function getProforma(proformaId: string) {
  isLoading.value = true;

  try {
    const result = (await apiGet(
      `proforma/GetProformaWithProfrmaId/${proformaId}`
    )) as GatResponseResult<ProformaWindow>;
    if (result.payload) {
      proformaWindow.value = result.payload;
    }
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
}

function setBackNavigation() {
  const result = [];
  if (props.callId) {
    result.push({ text: 'port call', href: `/call/${props.callId}` });
    result.push({ text: 'proforma list', href: `/call/${props.callId}/proforma` });
  }
  toolbarStore.setBackNavigation(result);
}

watch(
  () => props.proformaId,
  (newValue) => {
    if (newValue) {
      getProforma(newValue);
      setBackNavigation();
    }
  },
  { immediate: true }
);

return { __sfc: true,props, isLoading, proformaWindow, toolbarStore, globalFormatDateTime, columns, getProforma, setBackNavigation, ProformaLines }
}

})